import * as React from 'react';
import { Link } from 'react-router-dom';
import './InfoSection.css';

interface InfoSectionProps {
  renderRows?: (prefix: string, obj: any) => React.ReactNode;
  showHeading?: boolean;
  headerRowClass?: string;
  keyPrefix?: string;
  keyValuePairs: any;
  heading?: string;
  icon?: React.ReactNode;
  compact?: boolean;
}

const getTableRows = (keyPrefix, keyValuePairs, compact = false) => {
  return keyValuePairs.map((obj, index) => {
    const valueClass =
      obj.value === 'Enabled' || obj.value === 'No'
        ? 'enabled'
        : obj.value === 'Disabled' || obj.value === 'Yes'
        ? 'disabled'
        : '';
    const rowClass = `info-section-row${compact ? ' compact-info-section-row' : ''}`;
    // need better solution as this doesn't support i18n
    if (obj.label === 'pWAN Name') {
      return (
        <tr className={rowClass} key={keyPrefix + '-' + (index + 2)}>
          <td className="info-section-key">{obj.label}</td>
          <td className={'info-section-value ' + valueClass}>
            <strong><Link to={`/wan/${obj.id}`}>{obj.value}</Link></strong>
          </td>
        </tr>
      );
    }
    return (
      <tr className={rowClass} key={keyPrefix + '-' + (index + 2)}>
        <td className="info-section-key">{obj.label}</td>
        <td className={'info-section-value ' + valueClass}>
          {valueClass ? <h4>{obj.value}</h4> : <strong>{obj.value}</strong>}
        </td>
      </tr>
    );
  });
};

export const InfoSection: React.FC<InfoSectionProps> = ({
  headerRowClass = 'info-section-header-row',
  keyValuePairs,
  renderRows,
  showHeading,
  heading,
  icon,
  compact = false,
}) => {
  const headerClass = showHeading ? headerRowClass : 'info-section-header-row-no-border';
  const keyPrefix = heading ? heading.replace(' ', '-').toLowerCase() : 'info-section';
  const tableRows =
    typeof renderRows === 'function'
      ? renderRows(keyPrefix, keyValuePairs)
      : getTableRows(keyPrefix, keyValuePairs, compact);
  return (
    <div className={`p-1 rounded${compact ? ' compact-info-section' : ''}`}>
      <table className="info-section">
        <tbody>
          {showHeading && (
            <tr className={headerClass} key={keyPrefix + '-1'}>
              <td width="100%" colSpan={2}>
                {icon} &nbsp;&nbsp;<strong>{heading}</strong>
              </td>
            </tr>
          )}
          {tableRows}
        </tbody>
      </table>
    </div>
  );
};